import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useFeatureSubscriptionConfig } from '@frontend/self-upgrade';

type UseIsCIEligibleAccount = {
  isCallIntelActive?: boolean;
  isCallIntelEligibleAccount?: boolean;
  activeLocationIds: string[];
  isLoading: boolean;
};

const CI_ACTIVE_STATES = [State.ACTIVE, State.PROMOTE]; // ACTIVE and PROMOTE states are considered active for Call Intelligence

// This is used in the Analytics app to determine if the location is eligible for the call intel feature.
export const useIsCallIntelEligibleAccount = (locationIds?: string[]): UseIsCIEligibleAccount => {
  const { isFeatureActiveInSomeLocations, isUpgradeOrTrialEligible, subscriptionDataList, isLoading } =
    useFeatureSubscriptionConfig({
      feature: Feature.CALL_INTELLIGENCE,
      checkBundleUpgrade: false,
      activeStates: CI_ACTIVE_STATES,
      locationIds,
    });

  const activeLocationIds =
    subscriptionDataList?.filter(({ isStateActive }) => isStateActive).map(({ locationId }) => locationId) || [];

  return {
    isCallIntelActive: isFeatureActiveInSomeLocations,
    isCallIntelEligibleAccount: isFeatureActiveInSomeLocations || isUpgradeOrTrialEligible,
    activeLocationIds,
    isLoading,
  };
};
